import {BaseFactory} from "../../../infrastructure/factories/base-factory";
import {CompetitionsResponseApiModel} from "../models/competitions.response-api-model";
import {CompetitionDomainModel} from "../../common/competition/models/competition-domain-model";
import {SportDomainModel} from "../../sports/models/sport-domain-model";
import {CountryDomainModel} from "../../common/country/models/country-domain-model";
import {CompetitionsResponseDomainModel} from "../models/competitions.response-domain-model";
import {BaseService} from "../../../infrastructure/domain-services/base-service";
import {LoggerUtils} from "../../../infrastructure/utils/logger/logger-utils";
import {TermsUtils} from "../../../infrastructure/utils/terms-utils";

export class CompetitionsFactory extends BaseFactory {

  static injectables = [...BaseService.injectables, LoggerUtils, TermsUtils];

  createResponse(apiModel: CompetitionsResponseApiModel) {
    const responseApiModel: CompetitionsResponseApiModel = new CompetitionsResponseApiModel(apiModel);

    return responseApiModel;
  }

  createDomainModel(response: CompetitionsResponseApiModel, competitionsDomainModel: Array<CompetitionDomainModel>, competitorsDomainModel, countriesDomainModel: Array<CountryDomainModel>, sportsDomainModel: Array<SportDomainModel>): CompetitionsResponseDomainModel {
    const domain: CompetitionsResponseDomainModel = new CompetitionsResponseDomainModel(response ,competitionsDomainModel,competitorsDomainModel, countriesDomainModel, sportsDomainModel);

    return domain;
  }

  updateApiModel(response: CompetitionsResponseApiModel, delta: CompetitionsResponseApiModel) {
    if (!response || !delta) {
      return;
    }

    this.updateModel(response, delta);

    this.updateApiModelArray(response.competitions, delta.competitions);
    this.updateApiModelArray(response.countries, delta.countries);
    this.updateApiModelArray(response.sports, delta.sports);

    return response;
  }
}

